module.exports = __webpack_public_path__ + "static/img/5-6.c55cf46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/5-6.png
// module id = cHQe
// module chunks = 25